/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import ReportProblemLink from 'components/ReportProblemLink';
import ZeroStateView from 'components/ZeroStateView';

const NotFound: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found</title>
        <meta name='description' content='Page Not Found' />
      </Helmet>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100vh',
          padding: 4,
        }}
      >
        <Paper
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          <ZeroStateView
            size='large'
            qIllustration='fourOFour'
            title='Oops! Page Not Found'
            description="We can't seem to find the page you're looking for."
            subDescription='Error Code: 404'
            animate={true}
            button={
              <Stack gap={1}>
                <Button variant='contained' component={Link} to='/' startIcon={<HomeRoundedIcon />}>
                  Return to Dashboard
                </Button>
                <ReportProblemLink type='button' feedbackSubject='report page not found' />
              </Stack>
            }
          />
        </Paper>
      </Box>
    </>
  );
};

export default NotFound;
